import axios from 'axios'
import { getProxyAccessToken } from '../../plugins/cookie-plugins'

const state = {
  authenticated: false,
  id: null,
  login: null,
  token: null,
  type: null,
  cashier: null,
  bets: [],
  bets_in_progress: [],
  bets_all: [],
  bets_all_in_progress: [],
  bets_count_all: 0,
  bets_count_all_in_progress: 0,
  modal_idle: false,
  language: null,
  timezone: null,
  detail_my_bet: [],
  agencyNet: null,
  agencyLogin: null,
  operatorNet: null,
  operatorLogin: null,
  canPlay: true,
  userIdOfUserToPlayBetFor: null,
  loginOfUserToPlayBetFor: null,
  profileType: null,
  bets_in_progress_cashout: {
    data: [],
    page: 1,
    totalPages: 1,
    numPerPage: 20,
    total: 0,
  },
}

const getters = {
  getAuthenticated(state) {
    return state.authenticated
  },

  getId(state) {
    return state.id
  },

  getLogin(state) {
    return state.login
  },

  getToken(state) {
    return state.token
  },
  getType(state) {
    return state.type
  },
  getCashier(state) {
    return state.cashier
  },

  getMyBets(state) {
    return state.bets
  },

  getMyBetsInProgress(state) {
    return state.bets_in_progress
  },

  getMyBetsAll(state) {
    return state.bets_all
  },

  getMyBetsInProgressAll(state) {
    return state.bets_all_in_progress
  },

  getDetailMyBets(state) {
    return state.detail_my_bet
  },

  getMyBetCounts(state, getters) {
    return state.bets_count_all
  },

  getModalIdle(state) {
    return state.modal_idle
  },

  getLanguage(state) {
    return state.language
  },

  getTimezone(state) {
    return state.timezone
  },

  getAgencyLogin(state) {
    return state.agencyLogin
  },

  getAgencyNet(state) {
    return state.agencyNet
  },

  getOperatorLogin(state) {
    return state.operatorLogin
  },

  getOperatorNet(state) {
    return state.operatorNet
  },

  getCanPlay(state) {
    return state.canPlay
  },

  getUserIdOfUserToPlayBetFor(state) {
    return state.userIdOfUserToPlayBetFor
  },

  getLoginOfUserToPlayBetFor(state) {
    return state.loginOfUserToPlayBetFor
  },
  getProfileType(state) {
    return state.profileType
  },
  isTerminalUser(state) {
    return state.profileType != null && state.profileType === 'TERMINAL'
      ? true
      : false
  },
  getMyBetsInProgressCashout(state) {
    return state.bets_in_progress_cashout.data || []
  },
  getMyBetsPaginationCashout(state) {
    return state.bets_in_progress_cashout
  },
}

const actions = {
  async setUserData(context, payload) {
    context.commit('SET_USER_DATA', payload)
  },

  async setModalIdle(context, payload) {
    context.commit('SET_MODAL_IDLE', payload)
  },

  async setDetailMyBet(context, payload) {
    context.commit('SET_DETAIL_MY_BETS', payload)
  },

  async fetchMyBets(context, payload) {
    const all =
      payload.all != undefined && payload.all != undefined ? payload.all : false
    const showOnlyMyBets =
      payload.showOnlyMyBets != null ? payload.showOnlyMyBets : null
    const dontShowCancelled = true
    const dontShowInReview = true
    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`

    const requestPayload = {
      id_user: context.rootGetters['user/getId'],
      all: all,
      dontShowCancelled: dontShowCancelled,
      dontShowInReview: dontShowInReview,
    }

    if (showOnlyMyBets != null) {
      requestPayload.onlyPlayedByMe = showOnlyMyBets
    }

    return await axios
      .post(`${url}`, requestPayload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
      .then(async res => {
        let betsToSave = res.data.data

        betsToSave = betsToSave.filter(el => {
          return el.result != 'cancelled'
        })
        context.commit('SET_MY_BETS', betsToSave)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async fetchMyBetsInProgress(context, payload) {
    const all =
      payload.all != undefined && payload.all != undefined ? payload.all : false
    const in_progress = true

    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`
    const data = await axios.post(
      `${url}`,
      {
        id_user: context.rootGetters['user/getId'],
        all: all,
        in_progress: in_progress,
      },
      {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      }
    )
    await context.commit('SET_MY_BETS_IN_PROGRESS', data.data.data)

    return data.data.data
  },

  async fetchMyBetsInProgressNoReviewNoCancelled(context, payload) {
    try {
      const all = payload.all !== undefined ? payload.all : false
      const in_progress = true
      const dontShowCancelled = true
      const dontShowInReview = true
      const dontShowAntepost = true

      const requestBody = {
        id_user: context.rootGetters['user/getId'],
        all,
        in_progress,
        dontShowCancelled,
        dontShowInReview,
        dontShowAntepost,
      }

      if (Array.isArray(payload.betTypes) && payload.betTypes.length > 0) {
        requestBody.betTypes = payload.betTypes
      }

      if (payload.page !== undefined && payload.numPerPage !== undefined) {
        requestBody.page = payload.page
        requestBody.numPerPage = payload.numPerPage
      }

      const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`
      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      await context.commit('SET_MY_BETS_IN_PROGRESS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error(
        'API Error in fetchMyBetsInProgressNoReviewNoCancelled:',
        error
      )
      await context.commit('SET_MY_BETS_IN_PROGRESS', [])
      return []
    }
  },

  async fetchMyBetsAll(context, payload) {
    const all =
      payload.all != undefined && payload.all != undefined ? payload.all : false

    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`
    return await axios
      .post(
        `${url}`,
        {
          id_user: context.rootGetters['user/getId'],
          all: all,
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        context.commit('SET_MY_BETS_ALL', res.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async fetchMyBetsInProgressAll(context, payload) {
    const all =
      payload.all != undefined && payload.all != undefined ? payload.all : false

    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`
    return await axios
      .post(
        `${url}`,
        {
          id_user: context.rootGetters['user/getId'],
          all: all,
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        context.commit('SET_MY_BETS_ALL', res.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async fetchMyBetsAllFilter(context, payload) {
    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets-filter`
    return await axios
      .post(
        `${url}`,
        { id_user: context.rootGetters['user/getId'], ...payload },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        context.commit('SET_MY_BETS_ALL', res.data.data)
        context.commit('SET_MY_BETS_COUNT', res.data.counts)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async fetchMyBetsAllWithoutCancelled(context, payload) {
    if (payload.result == null) {
      payload.dontShowCancelled = true
      payload.dontShowInReview = true
    }

    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets-filter`
    return await axios
      .post(
        `${url}`,
        { id_user: context.rootGetters['user/getId'], ...payload },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        context.commit('SET_MY_BETS_ALL', res.data.data)
        context.commit('SET_MY_BETS_COUNT', res.data.counts)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async fetchMyBetsInProgressAllFilter(context, payload) {
    const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets-filter`
    return await axios
      .post(
        `${url}`,
        { id_user: context.rootGetters['user/getId'], ...payload },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        context.commit('SET_MY_BETS_ALL_IN_PROGRESS', res.data.data)
        context.commit('SET_MY_BETS_COUNT_IN_PROGRESS', res.data.counts)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async removeUserData(context, payload) {
    context.commit('REMOVE_USER_DATA')
  },

  async setCanPlay(context, payload) {
    context.commit('SET_CAN_PLAY', payload)
  },

  async setUserIdOfUserToPlayBetFor(context, payload) {
    context.commit('SET_USER_ID_OF_USER_TO_PLAY_BET_FOR', payload)
  },

  async setLoginOfUserToPlayBetFor(context, payload) {
    context.commit('SET_LOGIN_OF_USER_TO_PLAY_BET_FOR', payload)
  },
  async fetchUserBalance(context, payload) {
    const customerId = payload.customerId
    const userId = payload.userId
    const proxyUrl = context.rootGetters['settings/getProxyUrl']

    if (proxyUrl == null) {
      return null
    }

    const url = `${context.rootGetters['settings/getProxyUrl']}/api/wallet/customers/${customerId}/users/${userId}/walletGroupBalances`

    return await axios({
      method: 'get',
      url: url,
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${getProxyAccessToken()}`,
      },
    })
  },

  async fetchUserSportBalance(context, payload) {
    const customerId = payload.customerId
    const userId = payload.userId
    const proxyUrl = context.rootGetters['settings/getProxyUrl']

    let url
    const headers = {
      'content-type': 'application/json',
    }

    if (proxyUrl == null) {
      const urlBase = context.rootGetters['settings/getPlatformSettings']
      url =
        urlBase.sircms_endpoint +
        `bookie/wallet/user/balances/users/${userId}/sport-bet-withdrawable-balance/`
    } else {
      url = `${proxyUrl}/api/wallet/customers/${customerId}/users/${userId}/transactiontypes/SPORT_BET/withdrawablebalances`
      headers['Authorization'] = `Bearer ${getProxyAccessToken()}`
    }

    return await axios({
      method: 'get',
      url: url,
      headers: headers,
    })
  },
  async getUserSportBalance(context, payload) {
    const apiResponse = await context.dispatch('fetchUserSportBalance', payload)

    let totalBalance = 0.0

    if (apiResponse != null) {
      const wallets = apiResponse.data != null ? apiResponse.data : null

      if (wallets != null && wallets.length > 0) {
        wallets.forEach(function (item) {
          totalBalance += item.balance
        })
      }
    }
    return totalBalance
  },

  async depositTransfer(context, payload) {
    const amount = payload.amount
    const customerId = payload.customerId
    const receiverIdUser = payload.receiverIdUser
    const receiverLogin = payload.receiverLogin
    const proxyUrl = context.rootGetters['settings/getProxyUrl']

    let url
    const headers = {
      'content-type': 'application/json',
    }

    const data_form = {
      customer: context.rootGetters['settings/getCustomerId'].toString(),
      amount: amount,
      reciever: receiverIdUser.toString(),
      reference: context.rootGetters['user/getId'].toString(),
      login: context.rootGetters['user/getLogin'].toString(),
      nameUser: receiverLogin,
      passCode: '123456', // todo ... this is a dirty fix remove me when server side ready
      eventDescription: 'Deposit',
    }

    if (proxyUrl == null) {
      const urlBase = context.rootGetters['settings/getPlatformSettings']
      url =
        urlBase.sircms_endpoint +
        `bookie/rexcash/self-transfer/self/transfer/deposit`
    } else {
      url = `${proxyUrl}/rexcash/self-transfer/self/transfer/deposit`
      headers['Authorization'] = `Bearer ${getProxyAccessToken()}`
    }

    return await axios({
      method: 'post',
      url: url,
      headers: headers,
      data: data_form,
    })
  },

  async fetchMyBetsInProgressCashoutPaginated(context, payload) {
    try {
      const all = payload.all !== undefined ? payload.all : false
      const in_progress = true
      const dontShowCancelled = true
      const dontShowInReview = true
      const dontShowAntepost = true

      const requestBody = {
        id_user: context.rootGetters['user/getId'],
        all,
        in_progress,
        dontShowCancelled,
        dontShowInReview,
        dontShowAntepost,
      }

      if (Array.isArray(payload.betTypes) && payload.betTypes.length > 0) {
        requestBody.betTypes = payload.betTypes
      }

      if (payload.page !== undefined && payload.numPerPage !== undefined) {
        requestBody.page = payload.page
        requestBody.numPerPage = payload.numPerPage
      }

      const url = `${context.rootGetters['settings/getBetApiUrl']}/bet/get-my-bets`
      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      await context.commit('SET_MY_BETS_IN_PROGRESS_CASHOUT', response.data)
      return response.data
    } catch (error) {
      console.error(
        'API Error in fetchMyBetsInProgressCashoutPaginated:',
        error
      )
      await context.commit('SET_MY_BETS_IN_PROGRESS_CASHOUT', {
        data: [],
        page: 1,
        totalPages: 1,
        numPerPage: 20,
        total: 0,
      })
      return { data: [], page: 1, totalPages: 1, numPerPage: 20, total: 0 }
    }
  },
}

const mutations = {
  SET_USER_DATA(state, payload) {
    state.authenticated = true
    state.id = payload.id
    state.login = payload.login
    state.token = payload.token
    state.type = payload.type
    state.cashier = payload.cashier
    state.language = payload.language
    state.timezone = payload.timezone
    state.agencyNet = payload.agencyNet
    state.agencyLogin = payload.agencyLogin
    state.operatorNet = payload.operatorNet
    state.operatorLogin = payload.operatorLogin
    state.profileType = payload.profileType
  },

  REMOVE_USER_DATA(state) {
    state.authenticated = false
    state.id = null
    state.login = null
    state.token = null
    state.type = null
    state.cashier = null
    state.language = null
    state.timezone = null
    state.agencyNet = null
    state.agencyLogin = null
    state.operatorNet = null
    state.operatorLogin = null
    state.canPlay = true
    state.userIdOfUserToPlayBetFor = null
    state.loginOfUserToPlayBetFor = null
    state.profileType = null
  },

  SET_MY_BETS(state, payload) {
    state.bets = payload
  },
  SET_MY_BETS_IN_PROGRESS(state, payload) {
    state.bets_in_progress = payload
  },
  SET_MY_BETS_ALL(state, payload) {
    state.bets_all = payload
  },
  SET_MY_BETS_ALL_IN_PROGRESS(state, payload) {
    state.bets_all_in_progress = payload
  },
  SET_MY_BETS_COUNT(state, payload) {
    state.bets_count_all = payload
  },
  SET_MY_BETS_COUNT_IN_PROGRESS(state, payload) {
    state.bets_count_all_in_progress = payload
  },
  SET_MODAL_IDLE(state, payload) {
    state.modal_idle = payload
  },
  SET_DETAIL_MY_BETS(state, payload) {
    state.detail_my_bet = payload
  },
  SET_CAN_PLAY(state, payload) {
    state.canPlay = payload
  },
  SET_USER_ID_OF_USER_TO_PLAY_BET_FOR(state, payload) {
    state.userIdOfUserToPlayBetFor = payload
  },
  SET_LOGIN_OF_USER_TO_PLAY_BET_FOR(state, payload) {
    state.loginOfUserToPlayBetFor = payload
  },
  SET_MY_BETS_IN_PROGRESS_CASHOUT(state, payload) {
    state.bets_in_progress_cashout = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
